import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetSystemPackages = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/packages`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load packages.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetSystemPackage = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/packages/get`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load package.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateSystemPackage = async (payload: {
  name: string;
  price: number;
  note?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/packages/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create package.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateSystemPackage = async (payload: {
  id: string;
  name?: string;
  price?: number;
  note?: string;
  status?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/packages/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update package.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const DeleteSystemPackage = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/packages/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete package.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetSystemPackageSubFeatures = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/packages/sub-features`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load package features.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const UpdateSystemPackageSubFeature = async (payload: {
  package_id: string;
  sub_feature_id: string;
  is_enable: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/packages/sub-features/update`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update package feature.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};
